import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";

export class VideoContent extends Component {
    
	constructor(props) {
        super(props);
    }
	
	render() {
        return (
            <Fragment>
			    <div className="model-container popup-video model-center model-backdrop-show cardModalAction sign-in-model">
			        <button onClick={this.props.toggleVideo} type="button" className="modal-close" data-dismiss="modal" aria-hidden="true"><img src="/images/close.svg" alt="close"/></button>
                    <div
                        aria-labelledby="model-title"
                        aria-describedby="model-content"
                        className="model-popup model-popuplg model-modal model-show"
                        role="dialog"
                        aria-live="assertive"
                        aria-modal="true"
                    >
                        <div className="modal-body">
						    <div className="video-container-inner">
                                <iframe src={this.props.videoSource} className="responsive-iframe" frameborder="0" allow="fullscreen;" allowfullscreen></iframe>
							</div>
						</div>                    
                    </div>
                </div>
			</Fragment>
		);
        
    }
}

VideoContent.contextType = AppContext;
export default VideoContent;


// WEBPACK FOOTER //
// ./src/components/general/include/VideoContent.js